import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@chatterbug/aaron'

import routes from 'src/lib/rails-routes/rails-routes'
import Card from 'src/ui/Card/Card'
import ActivityLabel from 'src/ui/ActivityLabel/ActivityLabel'
import { t } from 'src/lib/i18n-react'

// happy to adjust naming here
import {
  flashcardsOne,
  flashcardsTwo,
  flashcardsThree,
  flashcardsFour,
  flashcardsFive,
} from './assets/flashcards'
import {
  audioOne,
  audioTwo,
  audioThree,
  audioFour,
  audioFive,
} from './assets/audio'
import {
  readingOne,
  readingTwo,
  readingThree,
  readingFour,
  readingFive,
} from './assets/reading'

const DEFAULT_IMAGES = {
  cards: [
    flashcardsOne,
    flashcardsTwo,
    flashcardsThree,
    flashcardsFour,
    flashcardsFive,
  ],
  audio: [audioOne, audioTwo, audioThree, audioFour, audioFive],
  reading: [readingOne, readingTwo, readingThree, readingFour, readingFive],
}

export const getRandomDefaultImage = (type) => {
  // not found, return first (or throw error?)
  if (!DEFAULT_IMAGES[type]) {
    return flashcardsOne
  }
  const pickIndex = Math.floor(Math.random() * DEFAULT_IMAGES[type].length)
  return DEFAULT_IMAGES[type][pickIndex]
}

const ActivityCard = ({
  coverImageUrl,
  id,
  format,
  heading,
  unit,
  identifier,
  l2Code,
  recommended,
  isQueueEmpty,
  countOfUnits,
}) => {
  const imageUrlWithFallback = coverImageUrl || getRandomDefaultImage(format)
  const activityUrl = isQueueEmpty
    ? routes.advanced_topic({
        code: l2Code,
        topic_id: id,
      })
    : routes.language_study({
        code: l2Code,
        activity: identifier,
        resume: 'false',
        recommended: recommended,
      })

  return (
    <Card
      height="100%"
      width="100%"
      imgUrl={imageUrlWithFallback}
      aspectRatio="2:1"
      title={heading}
      subtitle={
        isQueueEmpty ? (
          t('%{num} units', { num: countOfUnits })
        ) : unit ? (
          <Text fontSize="sm">{unit.name}</Text>
        ) : null
      }
      linkUrl={activityUrl}
      label={<ActivityLabel type={format} />}
    />
  )
}

ActivityCard.propTypes = {
  coverImageUrl: PropTypes.string,
  format: PropTypes.string,
  heading: PropTypes.string.isRequired,
  unit: PropTypes.shape({
    name: PropTypes.string,
  }),
  identifier: PropTypes.string,
  l2Code: PropTypes.string.isRequired,
  recommended: PropTypes.bool,
  isQueueEmpty: PropTypes.bool,
  id: PropTypes.string,
  countOfUnits: PropTypes.number,
}

export default ActivityCard
